export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/appsumo-plus-bg-red.58774ed0.svg","height":25,"width":47};